import { HashRouter as Router, Route, Routes, Navigate  } from 'react-router-dom';
import { useState, useEffect } from 'react';
import FooterNav from './components/FooterNav';
import Dictionary from './pages/Dictionary';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Brand from './components/Brand';
import Molecule from './components/Molecule';
import YourLearning from './components/YourLearning';
import BrandDetails from './components/BrandDetails';
import MoleculeDetails from './components/MoleculesDetails';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAuth } from './AuthContext';

export default function App() {
  const { isLoggedIn } = useAuth();

  return (
    <Router>
      <div className="app d-flex flex-column vh-100">
        <div className="flex-grow-1 overflow-auto">
          <Routes>
            <Route path="/" element={<Navigate to={isLoggedIn ? "/home" : "/login"} />} />
            <Route path="/login" element={<Login />} />
            {/* Main Routes */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>}/>
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/dictionary" element={<ProtectedRoute><Dictionary /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/brand" element={<ProtectedRoute><Brand /></ProtectedRoute>} />
            <Route path="/brandDetails/:id" element={<ProtectedRoute><BrandDetails /></ProtectedRoute>} />
            <Route path="/molecule" element={<ProtectedRoute><Molecule /></ProtectedRoute>} />
            <Route path="/moleculeDetails/:id" element={<ProtectedRoute><MoleculeDetails /></ProtectedRoute>} />
            <Route path="/yourLearning" element={<ProtectedRoute><YourLearning /></ProtectedRoute>} />
          </Routes>
        </div>
       {isLoggedIn && <FooterNav />}
      </div>
    </Router>
  );
}
